module.exports = __webpack_public_path__ + "media/images/products/banners/trade_dos_5_dias-cfa35beb37f07dfca07d9989495b9382.png";